import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Intent } from './intent';
import { OmniSearchService } from './omni-search.service';

@Component({
  template: `
    <h2 mat-dialog-title>{{ 'OMNISEARCH.WHAT_WOULD_YOU_LIKE_TO_DO' | translate }}</h2>
    <div class="searchbox">
      <mat-form-field floatLabel="never">
        <input
          matInput
          #searchTerm
          [placeholder]="'OMNISEARCH.TYPE_A_SHORTCUT_KEY' | translate"
          (keyup)="search(searchTerm.value)"
        />
      </mat-form-field>
    </div>
    <mat-dialog-content>
      <mat-nav-list>
        <a
          mat-list-item
          tabindex="0"
          *ngFor="let intent of filteredIntents$ | async"
          (click)="fulfillIntent(intent)"
          (keyup.enter)="fulfillIntent(intent)"
        >
          <h4 matListItemTitle class="row-title no-indent">
            {{ intent.title | translate }}
            <span class="key">{{ intent.shortcut }}</span>
          </h4>
          <p matListItemLine>{{ intent.description | translate }}</p>
        </a>
      </mat-nav-list>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-stroked-button mat-dialog-close>{{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./common.scss'],
  standalone: false,
})
export class OmniSearchComponent {
  private intents$: Observable<Intent[]>;
  private searchTerm$$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  filteredIntents$: Observable<Intent[]>;

  constructor(
    public dialogRef: MatDialogRef<OmniSearchComponent>,
    private omnisearchService: OmniSearchService,
    private router: Router,
  ) {
    this.intents$ = this.omnisearchService.intents$;
    this.filteredIntents$ = combineLatest([this.searchTerm$, this.intents$]).pipe(
      tap(([searchTerm, intents]) => {
        intents.forEach((intent) => {
          if (intent.shortcut === searchTerm) {
            this.fulfillIntent(intent);
          }
        });
      }),
      map(([searchTerm, intents]) => intents.filter((intent) => this.filterIntent(intent, searchTerm))),
    );
  }

  private filterIntent(intent: Intent, searchTerm: string): boolean {
    searchTerm = searchTerm.toLowerCase();
    return (
      intent.title.toLowerCase().indexOf(searchTerm) > -1 ||
      intent.description.toLowerCase().indexOf(searchTerm) > -1 ||
      intent.shortcut.toLowerCase().indexOf(searchTerm) > -1
    );
  }

  get searchTerm$(): Observable<string> {
    return this.searchTerm$$.asObservable();
  }

  search(searchTerm: string): void {
    this.searchTerm$$.next(searchTerm);
  }

  fulfillIntent(intent: any): void {
    if (typeof intent.callback !== 'undefined') {
      intent.callback(intent.itemOfIntent);
    } else if (typeof intent.routerUrl !== 'undefined') {
      this.router.navigateByUrl(intent.routerUrl);
    }
    this.dialogRef.close();
  }
}
